import { render, staticRenderFns } from "./OpenWebhook.vue?vue&type=template&id=652522d4&scoped=true&"
import script from "./OpenWebhook.vue?vue&type=script&lang=js&"
export * from "./OpenWebhook.vue?vue&type=script&lang=js&"
import style0 from "./OpenWebhook.vue?vue&type=style&index=0&id=652522d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "652522d4",
  null
  
)

export default component.exports